import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-full-width-layout',
  imports: [RouterOutlet],
  templateUrl: './full-width-layout.html',
  styleUrl: './full-width-layout.css',
})
export class FullWidthLayout {}
